import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMasterPallete, createMasterPallete } from "./masterPalleteSlice";
import { useReactToPrint } from "react-to-print";
import PrintLabels from "./PrintLabels";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment";
import "moment/locale/id";
import { toast } from "react-toastify";

moment.locale("id");


export default function MasterPalletePage() {
    const dispatch = useDispatch();
    const printRef = useRef();

    const masterPallete = useSelector((state) => state.masterPallete);
    const [printData, setPrintData] = useState([]);
    const [printMode, setPrintMode] = useState("multi"); 
    const [selectedIds, setSelectedIds] = useState([]);
    const pagination = masterPallete?.pagination || {};
    const [search, setSearch] = useState("");

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        documentTitle: "QR Labels",
        pageStyle: `
      @page {
        size: 101mm 53mm;
        margin: 0;
      }
      body {
        margin: 0;
      }
    `,
    });

    const handlePrintClick = async () => {
        if (printMode === "multi") {
            const res = await dispatch(fetchMasterPallete({
                ...filters,
                page: 1,
                per_page: 1000, // ambil semua
            })).unwrap();

            setPrintData(res.data); // simpan ke state khusus print
        } else {
            setPrintData(
                data.filter((item) => selectedIds.includes(item.id))
            );
        }

        setTimeout(() => {
            handlePrint();
        }, 300);
    };

    const data = masterPallete?.data || [];
    const loading = masterPallete?.loading || false;

    const [filters, setFilters] = useState({
        search: "",
        page: 1,
        per_page: 12,
    });

    const [form, setForm] = useState({
        code: "",
        bins_name: "",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.code || !form.bins_name) {
            toast.error("Semua field wajib diisi");
            return;
        }

        try {
            const res = await dispatch(createMasterPallete(form)).unwrap();

            toast.success(res?.message || "Data berhasil disimpan");

            // reset form
            setForm({
                code: "",
                bins_name: "",
            });

            // refresh data
            dispatch(fetchMasterPallete(filters));

        } catch (err) {
            if (err?.message && typeof err.message === "object") {
                const errors = Object.values(err.message)
                    .flat()
                    .join("\n");

                toast.error(errors);
            } else if (err?.message) {
                toast.error(err.message);
            } else {
                toast.error("Gagal tambah data");
            }
        }
    };

    useEffect(() => {
        dispatch(fetchMasterPallete(filters));
    }, [dispatch, filters]);

    const changePage = (page) => {
        setFilters((prev) => ({
            ...prev,
            page,
        }));
    };

    return (
        <div className="p-6 space-y-6">
            <h1 className="text-2xl font-bold mb-4 no-print print:hidden">Master Palette</h1>

            <div className="bg-white p-4 rounded shadow no-print print:hidden">
                <h2 className="font-semibold mb-3">Tambah Pallet</h2>

                <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
                    <input
                        type="text"
                        placeholder="Code"
                        value={form.code}
                        onChange={(e) =>
                            setForm({ ...form, code: e.target.value })
                        }
                        className="border px-3 py-2 rounded flex-1"
                    />

                    <input
                        type="text"
                        placeholder="Bins Name"
                        value={form.bins_name}
                        onChange={(e) =>
                            setForm({ ...form, bins_name: e.target.value })
                        }
                        className="border px-3 py-2 rounded flex-1"
                    />

                    <button
                        type="submit"
                        className="px-4 py-2 bg-green-500 text-white rounded"
                    >
                        Simpan
                    </button>
                </form>
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-4 no-print print:hidden">
                <input
                    type="text"
                    placeholder="Search..."
                    className="flex-1 border px-3 py-2 rounded"
                    value={filters.search}
                    onChange={(e) =>
                        setFilters({ ...filters, search: e.target.value, page: 1 })
                    }
                />

                {/*<button
                    onClick={() => window.print()}
                    className="px-4 py-2 bg-blue-500 text-white rounded whitespace-nowrap"
                >
                    Print QR
                </button>*/}

                <div className="flex items-center gap-4 mb-2">
                    <label className="flex items-center gap-1">
                        <input
                            type="radio"
                            value="multi"
                            checked={printMode === "multi"}
                            onChange={() => setPrintMode("multi")}
                        />
                        Cetak Semua
                    </label>

                    <label className="flex items-center gap-1">
                        <input
                            type="radio"
                            value="single"
                            checked={printMode === "single"}
                            onChange={() => setPrintMode("single")}
                        />
                        Pilih
                    </label>
                </div>

                <div>
                    <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={handlePrintClick}>
                        Print QR
                    </button>

                    {/* hidden area for printing */}
                    <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
                        <PrintLabels
                            ref={printRef}
                            data={printData}
                        />
                    </div>
                </div>
            </div>

            <div className="bg-white shadow overflow-hidden print:shadow-none print:bg-transparent">
                <div className="grid grid-cols-4 gap-4 p-4 print:p-0">
                    {data.map((item) => (
                        <div className="page" key={item.id}>
                            <div className="print-item flex flex-col items-center justify-center border border-gray-200 p-2 relative">

                                {printMode === "single" && (
                                    <input
                                        type="checkbox"
                                        className="absolute top-1 left-1"
                                        checked={selectedIds.includes(item.id)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedIds([...selectedIds, item.id]);
                                            } else {
                                                setSelectedIds(selectedIds.filter((id) => id !== item.id));
                                            }
                                        }}
                                    />
                                )}

                                <div className="print-item flex items-center p-2 relative">
                                    <QRCodeCanvas value={item.code} size={120} />

                                    {/* Info di kanan */}
                                    <div className="ml-2 text-xs font-bold bg-white px-1 rounded text-right">
                                        <div>{item.code}</div>
                                        <div className="text-[10px] font-normal">
                                            {item.bins_name}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </div>


            <div className="flex justify-between mt-4">
                <span>
                    Page {pagination?.current_page || 0} of {pagination?.last_page || 0}
                </span>

                <div className="flex gap-2">
                    <button
                        disabled={!pagination?.prev_page_url}
                        onClick={() => changePage(pagination.current_page - 1)}
                    >
                        Prev
                    </button>

                    <button
                        disabled={!pagination?.next_page_url}
                        onClick={() => changePage(pagination.current_page + 1)}
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
}
